import * as actions from './actions';
import * as api from './api';
import * as functions from './functions';
import reducer from './reducer';

const reducers = {
  app: reducer,
};

export {
 actions, api, functions, reducers,
};
